/** Standard virtual-currency disclaimer for Meta / social-gaming compliance surfaces. */
export const VIRTUAL_CURRENCY_DISCLAIMER =
    "Cricket8 is a free-to-play social cricket game. Coins, Rubies and XP are virtual in-game currencies, have no monetary value and cannot be exchanged or withdrawn for cash.";

/** Meta / ad-aligned free-to-play line for high-visibility UI chrome (sentence parts). */
export const FTP_DISCLAIMER_SHORT_LINES = [
    "Free-to-play cricket games.",
    "Virtual Coins have no cash value.",
    "No cash prizes.",
] as const;

/** Single-string form of {@link FTP_DISCLAIMER_SHORT_LINES} (tooltips, aria, one-line layouts). */
export const FTP_DISCLAIMER_SHORT = FTP_DISCLAIMER_SHORT_LINES.join(" ");
/** Compact eyebrow / ticker form of the FTP disclaimer. */
export const FTP_DISCLAIMER_COMPACT =
    "Free to play · Virtual Coins have no cash value · No cash prizes";

/** Short line for shop purchase / convert CTAs. */
export const VIRTUAL_CURRENCY_SHOP_NOTE = "Virtual Coins have no cash value. No cash equivalents.";
